import { statsConsts } from "./actions"
const initState = {
    selectedMentorCategory: 'All'
}
const reducer = (state = initState, action) => {
    const payload = action.payload
    switch (action.type) {

        case statsConsts.SELECT_MENTOR_CATEGORY:
            return {
                ...state,
                selectedMentorCategory: payload
            }
        default:
            return state;
    }

};
export default reducer;
